<div *ngIf="isOpen" class="modal-bg">

    <div class="modal-card">
        <h5>Sell-Out Details: </h5>
        <div class="details-container">

            <div class="row-div">
                <div class="details-div">
                    <label for="">Reference Id:</label>
                    <input type="text" [value]="details.reference_id ?? 'N/A'" disabled>
                </div>
                <div class="details-div">
               </div>
            </div>

            <div class="row-div">
                <div class="details-div">
                    <label for="">Wallet:</label>
                    <input type="text" [value]="details.wallet ?? 'N/A'" disabled>
                </div>

                <div class="details-div">                    

                    <label *ngIf="details.dealer">Dealer:</label>
                    <input *ngIf="details.dealer" type="text" [value]="details.dealer ?? 'N/A'" disabled>
                    
                    <label *ngIf="details.subdealer">Dealer:</label>
                    <input *ngIf="details.subdealer" type="text" [value]="details.subdealer ?? 'N/A'" disabled>
                    
                    <label *ngIf="details.retailer">Dealer:</label>
                    <input *ngIf="details.retailer" type="text" [value]="details.retailer ?? 'N/A'" disabled>
                    
                </div>

            </div>

            <div class="row-div">
                <div class="details-div">
                    <label for="">SKU:</label>
                    <input type="text" [value]="details.sku ?? 'N/A'" disabled>
                </div>
                <div class="details-div">
                    <label for="">Product Name:</label>
                    <input type="text" [value]="details.product_name ?? 'N/A'" disabled>
                </div>
            </div>
            

            <div class="row-div">
                <div class="details-div">
                    <label for="">Seller Username:</label>
                    <input type="text" [value]="details.seller_username ?? 'N/A'" disabled>
                </div>
                <div class="details-div">
                    <label for="">Seller Level:</label>
                    <input type="text" [value]="details.seller_level ?? 'N/A'" disabled>
                </div>
            </div>
            
            <div class="row-div">
                <div class="details-div">
                    <label for="">Recipient Mobile:</label>
                    <input type="text" [value]="details.recipient_mobile ?? 'N/A'" disabled>
                </div>
                <div class="details-div">
                    <label for="">Recipient Account No.:</label>
                    <input type="text" [value]="details.account_no ?? 'N/A'" disabled>
                </div>
            </div>

            <div class="row-div">
            
                <div class="details-div">
                    <label for="">Transaction Amount:</label>
                    <input type="text" [value]="details.amount_of_transaction ? '₱'+globalservice.numberWithCommas(details.amount_of_transaction) : 'N/A'" disabled>
                </div>
            
                <div class="details-div">
                </div>
            
            </div>

            <div class="row-div">
             
                <div class="details-div">
                    <label for="">Seller Initial Balance:</label>
                    <input type="text" [value]="details.seller_initial_balance ? '₱'+globalservice.numberWithCommas(details.seller_initial_balance) : 'N/A'" disabled>
                </div>
            
                <div class="details-div">
                    <label for="">Seller End Balance:</label>
                    <input type="text" [value]="details.seller_end_balance ? '₱'+globalservice.numberWithCommas(details.seller_end_balance) : 'N/A'" disabled>
                </div>
            </div>
            

            <div class="row-div">
                <div class="details-div">
                    <label for="">Date of Order:</label>
                    <input type="text" [value]="details.date_order ? globalservice.dateToString(details.date_order) : 'N/A'" disabled>
                </div>
                <div class="details-div">
                    <label for="">Date of Order Completion:</label>
                    <input type="text" [value]="details.date_order_completion ? globalservice.dateToString(details.date_order_completion) : 'N/A'" disabled>
                </div>
                <div class="details-div">
                    <label for="">Completion Duration:</label>
                    <input type="text" [value]="details.duration ? (details.duration+'s') : 'N/A'" disabled>
                </div>
            </div>

        </div>
        <button (click)="closeModal()" class="close-button"> Close </button>
    
    </div>

</div>